import React from 'react';

export default function Spinner({ size = 'md', label = 'Loading…' }) {
  const sizeClass = size === 'sm' ? 'h-4 w-4 border-2' : size === 'lg' ? 'h-10 w-10 border-4' : 'h-6 w-6 border-2';
  return (
    <span role="status" aria-label={label} className="inline-flex items-center justify-center">
      <span className={`${sizeClass} rounded-full border-blue-500 border-t-transparent animate-spin block`} />
      <span className="sr-only">{label}</span>
    </span>
  );
}
